export enum ConnectMatchingAPIViewTypes {
  BASIC = 'basic',
  FULL = 'full',
}
